module.exports = __webpack_public_path__ + "img/coupon_empty.b70e2d78.png";